import axios from 'axios';
import API_CONFIG from '../config/apiConfig';

const api = axios.create({
  baseURL: API_CONFIG.API_URL,
  withCredentials: true,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
});

api.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem('access_token');
  const legacyToken = localStorage.getItem('token');
  config.headers = config.headers || {};

  // FormData requests need the browser/Axios adapter to set the multipart
  // boundary. A global JSON default otherwise causes Django to reject profile
  // updates with 415 Unsupported Media Type.
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    if (typeof config.headers.delete === 'function') {
      config.headers.delete('Content-Type');
    } else {
      Object.keys(config.headers).forEach((header) => {
        if (header.toLowerCase() === 'content-type') delete config.headers[header];
      });
    }
  }

  if (accessToken) {
    config.headers['Authorization'] = `Bearer ${accessToken}`;
  } else if (legacyToken) {
    config.headers['Authorization'] = `Token ${legacyToken}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error || {};
    if (response && response.status === 401 && config && config.headers && config.headers['Authorization'] && !config._retryWithoutAuth) {
      // Retry once without Authorization to allow session-based auth
      const newConfig = { ...config, headers: { ...config.headers } };
      delete newConfig.headers['Authorization'];
      newConfig._retryWithoutAuth = true;
      try {
        return await api(newConfig);
      } catch (e) {
        throw e;
      }
    }
    throw error;
  }
);

export default api;
